<template>
    <b-container fluid id="tables">
        <b-row class="d-flex justify-content-center text-center">
            <b-col lg="3" xs="3" md="3" xl="3" class="my-3">
                <input class="form-control ShifokrSverka" type="date" v-model="datas.date1" />
            </b-col>
            <b-col lg="3" xs="3" md="3" xl="3" class="my-3">
                <input class="form-control ShifokrSverka" type="date" v-model="datas.date2" />
            </b-col>
            <b-col lg="3" xs="4" md="4" xl="4" class="my-3">
                <b-input v-if="localUser.role == 'Shifokor'" v-model="doctor" disabled>
                </b-input>
                <v-select :options="names" v-model="datas.user_id" :reduce="names => names.id" label="user_name"
                    :placeholder="$t('Ҳодимни танланг...')" v-else />
            </b-col>
            <b-col xs="3" md="3" xl="3" class="my-3 d-flex align-items-center justify-content-start">
                <button type="button" class="btn text-white mr-2" style="background: #195FB0; width: 100px; font-size: 14px"
                    @click="Send()">
                    <img src="../../../public/Vector.png" alt="" style="margin-right: 5px" />
                    {{ $t("Кўриш") }}
                </button>
                
                <!-- Excel tugmasi har doim ko'rinadi -->
                <button type="button" class="btn btn-success text-white mr-2" style="width: 100px; font-size: 14px"
                    @click="exportToExcel()">
                    <b-icon icon="file-earmark-excel" class="mr-1"></b-icon>
                    Excel
                </button>

                <b-button class="navbarBtnDanger" variant="danger" @click="cancel()">
                    <b-icon icon="x-circle-fill"></b-icon>
                </b-button>
            </b-col>
        </b-row>

        <div class="tablesD">
            <table class="table table-bordered table-sm table-striped" id="my-table">
                <thead>
                    <tr class="bg-dark text-white">
                        <th style="width: 50px;">№</th>
                        <th>{{ $t("Номи") }}</th>
                        <th style="width: 100px;">{{ $t("Сони") }}</th>
                        <th style="width: 150px;">{{ $t("Сумма") }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in results" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td class="text-left px-3">{{ item.inspection_name ? item.inspection_name.name : '' }}</td>
                        <td>{{ item.count }}</td>
                        <td>{{ item.summa | numFormat }}</td>
                    </tr>
                    <!-- Ma'lumot yo'q bo'lganda ko'rinadigan qator -->
                    <tr v-if="results.length === 0">
                        <td colspan="4" class="text-center text-muted py-3">Ma'lumotlar mavjud emas. "Ko'rish" tugmasini bosing.</td>
                    </tr>
                </tbody>
                <tfoot v-if="results.length > 0">
                    <tr class="font-weight-bold" style="background: #f4f7fb;">
                        <td colspan="2" class="text-right px-3">{{ $t('Жами') }}:</td>
                        <td>{{ totalCount }}</td>
                        <td>{{ totalSumma | numFormat }}</td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </b-container>
</template>

<script>
import moment from "moment";
import axios from "axios";
import * as XLSX from 'xlsx';

export default {
    data() {
        return {
            datas: {
                date1: new Date().toISOString().slice(0, 8) + "01",
                date2: new Date().toISOString().slice(0, 10),
                user_id: null
            },
            results: [],
            names: [],
            doctor: '',
            localUser: JSON.parse(localStorage.getItem("user"))
        };
    },
    computed: {
        totalCount() {
            return this.results.reduce((acc, item) => acc + (parseFloat(item.count) || 0), 0);
        },
        totalSumma() {
            return this.results.reduce((acc, item) => acc + (parseFloat(item.summa) || 0), 0);
        }
    },
    filters: {
        numFormat: function (value) {
            if (!value) return "0";
            return new Intl.NumberFormat().format(value);
        }
    },
    created() {
        let self = this;
        if (JSON.parse(localStorage.getItem("datas")) && self.localUser.role != "Shifokor") {
            const storedDatas = JSON.parse(localStorage.getItem("datas"));
            self.datas.date1 = storedDatas.date1;
            self.datas.date2 = storedDatas.date2;
            self.datas.user_id = storedDatas.user_id;
            self.Send();
            localStorage.removeItem("datas");
        }
        if (self.localUser.role == "Shifokor") {
            self.datas.user_id = self.localUser.doctor.id;
            self.doctor = self.localUser.doctor.name;
        }
    },
    methods: {
        Send() {
            let self = this;
            var params = {
                datetime1: parseInt(new Date(self.datas.date1).valueOf().toString().slice(0, 10)),
                datetime2: parseInt(new Date(self.datas.date2).valueOf().toString().slice(0, 10)) + 86399,
                user_id: self.datas.user_id
            };
            axios({
                method: "post",
                url: "hisobot/tekshiruv_oylik",
                data: params
            }).then(function (res) {
                if (!res.data.error) {
                    self.results = res.data.data;
                }
            }).catch(err => {
                console.error("Xatolik yuz berdi:", err);
            });
        },
        exportToExcel() {
            if (this.results.length === 0) {
                this.$bvToast.toast("Eksport qilish uchun ma'lumot topilmadi. Avval 'Ko'rish' tugmasini bosing.", {
                    title: 'Ogohlantirish',
                    variant: 'warning',
                    solid: true
                });
                return;
            }

            // 1. Sarlavhalarni tayyorlash
            const header = [["№", "Xizmat Nomi", "Soni", "Summasi (so'm)"]];
            
            // 2. Ma'lumotlarni qatorlarga yig'ish
            const rows = this.results.map((item, index) => [
                index + 1,
                item.inspection_name ? item.inspection_name.name : '',
                item.count,
                item.summa
            ]);
            
            // 3. Jami qatorini qo'shish
            const footer = [["", "JAMI:", this.totalCount, this.totalSumma]];
            
            const worksheetData = [...header, ...rows, ...footer];

            // 4. Worksheet yaratish
            const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

            // 5. Ideal ustun kengliklarini sozlash
            const colWidths = [
                { wch: 5 },  // №
                { wch: 50 }, // Nomi (Kengroq qilindi)
                { wch: 12 }, // Soni
                { wch: 20 }  // Summa
            ];
            worksheet['!cols'] = colWidths;

            // 6. Workbook yaratish va yuklash
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Oylik_Hisobot");

            const fileName = `Hisobot_${this.datas.date1}_${this.datas.date2}.xlsx`;
            XLSX.writeFile(workbook, fileName);
        },
        cancel() {
            window.close();
        },
        getDoctor() {
            let self = this;
            axios({
                method: "get",
                url: "/user/all"
            }).then(res => {
                if (!res.error) {
                    res.data.data.forEach(el => {
                        if (el.role === "Shifokor" || el.role === "Loborant" || el.role === "Hamshira") {
                            self.names.push(el);
                        }
                    });
                }
            });
        }
    },
    mounted() {
        this.getDoctor();
    }
};
</script>

<style scoped>
.table {
    margin: 0px 0px !important;
}

label, td, th, tr {
    font-family: "Times New Roman", Times, serif;
    font-weight: bolder;
    text-transform: capitalize;
    font-size: 15px;
    height: 30px !important;
    text-align: center;
}

.text-left {
    text-align: left !important;
}

.ShifokrSverka {
    border-radius: 3px;
    background: #fff;
    border: 1px solid rgb(210, 210, 210);
}

.navbarBtnDanger {
    border: 1px solid #fff;
    background: #e80a18;
    border-radius: 8px;
}

#tables {
    height: 100vh !important;
    width: 99% !important;
}

th {
    color: #195fb0;
    background-color: #f4f7fb;
    position: sticky;
    top: 0;
    z-index: 2;
}

.tablesD {
    max-height: calc(100vh - 100px);
    overflow-y: auto;
}
</style>